import { InvoicePreviewTableProvider, useInvoicePreviewTable } from '@/pages/InvoicePreview/InvoicePreviewTable';

import { InvoiceTrip } from '@/models/gen/graphql';
import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import { useSimpleTableRowContext } from '@/components/SimpleTable/SimpleTableRow';

const CrewIdCell = (): JSX.Element => {
  const [{ payerProviderId, clientIdsThatRequireCrew }] = useInvoicePreviewTable<{
    payerProviderId: string;
    clientIdsThatRequireCrew: string[];
  }>(({ payerProviderId, clientIdsThatRequireCrew }: InvoicePreviewTableProvider) => ({ payerProviderId, clientIdsThatRequireCrew }));
  const {
    data: { crewId, firstName, lastName },
  } = useSimpleTableRowContext<InvoiceTrip>();
  const displayParts = [(crewId || '--')?.toString?.() || '--'];
  if (clientIdsThatRequireCrew?.includes(payerProviderId)) displayParts.push(firstName, lastName);
  const display = displayParts
    .filter((str) => !!str)
    .join(' ')
    .trim();

  return <SimpleTableCell name="CREW_ID">{display}</SimpleTableCell>;
};

export default CrewIdCell;
